module.exports = __webpack_public_path__ + "img/android-icon-144x144.51879ed.png";